import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Spacing } from '../../styles';
import { Button } from '../crop-circle/Button';
import { SystemNotification } from '../system-notification';
import { BottomBar } from './bottomBar';
import { RestartButton } from './restartButton';
import { BottomComponentBarBaseProps } from './types';

export const BottomComponentBar = (props: BottomComponentBarBaseProps) => {
  const isWeb = Platform.OS === 'web';
  const left = props.left || props.backButton;
  const right = props.right ? (
    props.right
  ) : props.onRightPress ? (
    <RestartButton
      onPress={props.onRightPress}
      disabled={props.rightPressDisabled}
    />
  ) : undefined;

  const centerBlock =
    props.additionalHeaderBlock ||
    (props.onSave ? (
      <SaveButton
        onPress={() => props.onSave?.()}
        disabled={props.rightPressDisabled}
        label={props.saveLabel}
        fontSize={!isWeb ? 14 : undefined}
        // When there's no right button, give the Save button a right margin
        // so it mirrors the Back button's left margin (symmetric layout).
        // When a right button is present (e.g. RestartButton), it already
        // brings its own margin, so don't double up.
        style={!right ? styles.saveButtonRightMargin : undefined}
      />
    ) : undefined);

  return (
    <>
      <BottomBar
        style={props.style}
        left={left}
        right={right}
        additionalHeaderBlock={centerBlock}
      />
      <SystemNotification />
    </>
  );
};

type SaveButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  isLoading?: boolean;
  activeTextColor?: string;
  fontSize?: number;
};

const SaveButton: FC<SaveButtonProps> = (props: SaveButtonProps) => {
  const { t } = useTranslation();
  const state = props.disabled ? 'default' : 'active';

  return (
    <Button
      onPress={props.onPress}
      style={StyleSheet.flatten([styles.saveButtonContainer, props.style])}
      state={state}
      disabled={props.disabled}
    >
      {props.label || t('topNav.save')}
    </Button>
  );
};

const styles = StyleSheet.create({
  saveButtonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
  saveButtonRightMargin: {
    marginRight: Spacing.baseMargin.base,
  },
});
